import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=1d08f796&scoped=true&"
import script from "./AddContact.vue?vue&type=script&lang=js&"
export * from "./AddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08f796",
  null
  
)

export default component.exports